import veeValidatePlugin from '@/plugins/vee-validate';
export function addPlugins({ app, router, pluginContext }) {
  const plugins = [veeValidatePlugin];
  plugins.forEach((plugin) => plugin({ app, router, pluginContext }));
}
